export default "__VITE_ASSET__CZ8NqUn0__"